import { render } from "./AdminTrackApprovedLiquidation.vue?vue&type=template&id=60b738ad"
import script from "./AdminTrackApprovedLiquidation.vue?vue&type=script&lang=js"
export * from "./AdminTrackApprovedLiquidation.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__